import { Injectable } from "@angular/core";
import { BaseFpxComponentState, BaseFpxFormHelper } from "@fpx/core";

export class FpxDynamicFormState extends BaseFpxComponentState {}

@Injectable()
export class FpxDynamicFormHelper extends BaseFpxFormHelper<FpxDynamicFormState> {
  constructor() {
    super(new FpxDynamicFormState());
  }
}
